import { useMediaQuery, useTheme } from "@mui/material";
import React, { createContext, useContext, useEffect, useState } from "react";

// Create the context
const ProfileVisibilityContext = createContext();

// Custom hook for consuming the context
export const useProfileVisibility = () => useContext(ProfileVisibilityContext);

// Provider component
export const ProfileVisibilityProvider = ({ children }) => {
  const [showProfile, setShowProfile] = useState(false);
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const toggleProfileVisibility = () => {
    setShowProfile((prev) => !prev);
  };
  useEffect(() => {
    if (!isMediumScreen) {
      setShowProfile(false);
    }
  }, [isMediumScreen]);
  return (
    <ProfileVisibilityContext.Provider
      value={{ showProfile, toggleProfileVisibility }}
    >
      {children}
    </ProfileVisibilityContext.Provider>
  );
};
